import {type ColorName, useNamedColor} from '@github-ui/use-named-color'
import {Box, Token} from '@primer/styled-react'

import {getTokenStyle} from './Shared'
import styles from './SingleSelectToken.module.css'

type SingleSelectTokenProps = {
  inputName: string
  inputColor: ColorName
}

export const SingleSelectToken = ({inputName, inputColor}: SingleSelectTokenProps) => {
  const color = useNamedColor(inputColor)
  return (
    <Token
      sx={{
        bg: color.bg,
        color: color.fg,
        borderColor: color.border,
        ':hover': {
          bg: color.bg,
          color: color.fg,
          borderColor: color.border,
        },
        ...getTokenStyle(inputName),
      }}
      size="medium"
      text={inputName}
      className={styles.Token}
    />
  )
}

export const SingleSelectLeadingVisual = ({inputColor}: Omit<SingleSelectTokenProps, 'inputName'>) => {
  const {bg, accent} = useNamedColor(inputColor)
  return (
    <Box
      sx={{
        bg,
        borderColor: accent,
      }}
      className={styles.colorIndicator}
    />
  )
}

try{ SingleSelectToken.displayName ||= 'SingleSelectToken' } catch {}
try{ SingleSelectLeadingVisual.displayName ||= 'SingleSelectLeadingVisual' } catch {}